<script>
export default {};
</script>
<template>
  <!-- This is intentionally left blank -->
  <div></div>
</template>
